




import Vue from 'vue'
import {
  lbzfChangeModeHandler,
  lbzfIsDarkModeEnabled,
  lbzfSetModeAttributes,
  lbzfSupportsCssVariables
} from '@lbzui/vue/src/utils/funcs'

export default Vue.extend({
  name: 'App',

  data: () => ({
    supportsCssVars: lbzfSupportsCssVariables()
  }),

  created(): void {
    if (this.supportsCssVars) {
      this.setTheme()
      lbzfChangeModeHandler(this.setTheme)
    }
  },

  methods: {
    setTheme(): void {
      const isDark: boolean = lbzfIsDarkModeEnabled()

      lbzfSetModeAttributes(isDark, {
        light: '#e10707',
        dark: '#000'
      })
    }
  }
})
